/**
 * External dependencies
 */
import React from "react";

/**
 * Internal dependencies
 */
import { AppWrapper, PostsWrapper, FiltersWrapper } from "../wrappers";
import PostsLoader from "./PostsLoader";
import FiltersLoader from "./FiltersLoader";

const AppLoader = ({ numOfFilters, numOfPosts }) => {
	return (
		<AppWrapper>
			<FiltersWrapper>
				<FiltersLoader numOfItems={numOfFilters} />
			</FiltersWrapper>
			<PostsWrapper>
				<PostsLoader numOfItems={numOfPosts} />
			</PostsWrapper>
		</AppWrapper>
	);
};

export default AppLoader;
